import React from 'react';
import {Link} from 'react-router-dom';
import './NavBar.css';

import logo from './logo.svg';
import cross from './cross.svg';

export const NavBar = (props) => {


	return(
		<nav className='navBar'>
			<figure className='mob-links'>
				<img id='cross'src={cross} alt="icon" onClick={props.handleNavBar}/>
			</figure>
			<figure className='logo'>
				<Link to='/dtn'  >
					<img src={logo} alt="logo" onClick={props.handleNavBar}/>
					<h1 onClick={props.handleNavBar}>Drop The Needle</h1>
				</Link>
			</figure>
			<ul>
				<li onClick={props.handleNavBar}><Link to='/latest'>Latest</Link></li>
				<li onClick={props.handleNavBar}><Link to='/labels'>Labels</Link></li>
				<li onClick={props.handleNavBar}><Link to='/news'>News</Link></li>
				<li onClick={props.handleNavBar}><Link to='/about'>About</Link></li>
			</ul>
		</nav>
	)

	

};
